import { jwtDecode } from "jwt-decode";

export const formatCurrency = (amount) => {
  return `$ ${amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const isTokenValid = (token) => {
  if (token) {
    const decoded = jwtDecode(token);
    if (decoded.exp * 1000 < Date.now()) {
      return false;
    } else return true;
  }
  return false;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhoneNumber = (phoneNumber, isUsPhoneNumber) => {
  const phoneRegex = isUsPhoneNumber
    ? /^(\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\s\d{3}-\d{4}|\d{10}|\(\d{3}\)\d{3}-\d{4})$/
    : /^\d{1,12}$/;
  return phoneRegex.test(phoneNumber);
};

export const convertToDollars = (value) => {
  if (value) {
    if (value === 0) {
      return "$0.00";
    }

    if (typeof value === "string") {
      value = Number(value.replace(/[^0-9.-]+/g, ""));
    }

    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(value);
  }

  return "$0.00";
};

export const getUniqueObjects = (data, key = "id", preferredKey = "bidderNumber", bidderKey = "bidderNumber") => {
  const grouped = data.reduce((acc, obj) => {
    const id = obj[key];
    if (!acc[id]) acc[id] = [];
    acc[id].push(obj);
    return acc;
  }, {});

  const unique = Object.values(grouped).flatMap(group => {
    const withBidder = group.filter(obj => obj[bidderKey] !== undefined && obj[bidderKey] !== null);
    if (withBidder.length > 0) {
      // keep all with bidderNumber, ignore those without
      return withBidder;
    } else {
      // if none have bidderNumber, pick preferred or first
      const preferred = group.find(obj => obj[preferredKey]) || group[0];
      return [preferred];
    }
  });

  // Sort: items with bidderNumber first
  const sorted = [
    ...unique.filter(obj => obj[bidderKey] !== undefined && obj[bidderKey] !== null),
    ...unique.filter(obj => obj[bidderKey] === undefined || obj[bidderKey] === null),
  ];

  return sorted;
};

